import { Subscription } from 'rxjs';

export class EnpsSubscriber {
    public subscriptions: Subscription = new Subscription();

    constructor() {
    }

    public createSubscription(prop: any, func: Function) {
        if (this.subscriptions) {
            let sub: Subscription = prop.subscribe(func);
            this.subscriptions.add(sub);
            return sub;
        }
    }

    public removeAllSubscriptions() {
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
        this.subscriptions = new Subscription();
    }
}
